module.exports = __webpack_public_path__ + "static/tablet@2x-06c688039152de30d2e87600a7cd743c.jpg";